<template>
  <b-navbar type="is-primary" wrapper-class="container" fixed-top transparent>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <logo />
      </b-navbar-item>
    </template>

    <template slot="start"></template>

    <template slot="end">
      <b-navbar-item tag="router-link" :to="{ path: '/ueber-uns' }"
        >Über uns</b-navbar-item
      >
      <b-navbar-item tag="router-link" :to="{ path: '/bluehbuffet' }"
        >Blühbuffet</b-navbar-item
      >
      <b-navbar-item tag="router-link" :to="{ path: '/bienenoasen' }"
        >Bienenoasen</b-navbar-item
      >
      <b-navbar-dropdown label="Anlässe" :collapsible="true">
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/originelles-mitbringsel' }"
          >Feier</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/blumen-zum-valentinstag' }"
          >Valentinstag</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/bluehpatenschaft-zu-ostern' }"
          >Ostern</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/originelle-idee-zum-muttertag' }"
          >Muttertag</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/blumen-verschenken-zur-geburt' }"
          >Geburt</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/nachhaltiges-geburtstagsgeschenk' }"
          >Geburtstag</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/blumen-zur-konfirmation' }"
          >Konfirmation</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/gastgeschenk-hochzeit' }"
          >Hochzeit</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/originelles-geschenk-hochzeitstag' }"
          >Hochzeitstag</b-navbar-item
        >
        <b-navbar-item tag="router-link" :to="{ path: '/mittsommer' }"
          >Mittsommer</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/nachhaltiges-geschenk-jubilaeum' }"
          >Jubiläum</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/nachhaltiges-weihnachtsgeschenk' }"
          >Weihnachten</b-navbar-item
        >
        <b-navbar-item tag="router-link" :to="{ path: '/freude-schenken' }"
          >Corona</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ path: '/bienenweide-patenschaft' }"
          >Einfach so</b-navbar-item
        >
      </b-navbar-dropdown>
      <b-navbar-item tag="router-link" :to="{ path: '/faq' }"
        >FAQ</b-navbar-item
      >
      <b-navbar-item tag="router-link" :to="{ path: '/kontakt' }"
        >Kontakt</b-navbar-item
      >
      <b-navbar-item tag="div">
        <div class="buttons">
          <router-link
            to="/landwirte"
            class="button is-hidden-touch is-primary is-inverted has-text-weight-bold navbtn"
            >Für Landwirte</router-link
          >
          <router-link
            to="/landwirte"
            class="button is-hidden-desktop is-primary has-text-weight-bold navbtn"
            >Für Landwirte</router-link
          >
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import Logo from "@/components/Logo.vue";
export default {
  name: "Navbar",
  components: {
    Logo
  }
};
</script>

<style lang="scss">
html.has-navbar-fixed-top,
body.has-navbar-fixed-top {
  padding-top: 5.5rem !important;
}

@media screen and (min-width: 1024px) {
  .navbar > .container .navbar-brand,
  .container > .navbar .navbar-brand {
    margin-left: -1.35rem !important;
  }
}

a.navbar-item,
a.navbar-link {
  font-weight: 700;
  font-size: 1.2rem;
  padding: 0.75rem 0.75rem;
  margin: 0rem 0.5rem;
  svg {
    max-height: 4rem;
    height: 4rem;
  }
}
a.navbar-item:hover svg path {
  fill: $white-ter;
}

a.navbar-link:not(.is-arrowless) {
  padding-right: 1.75em;
}
a.navbar-link:not(.is-arrowless)::after {
  margin-top: -0.5em;
  right: 0.75em;
  font-size: 0.9rem;
}
.navbar.is-primary .navbar-end > a.navbar-item.is-active,
.navbar.is-primary .navbar-end > a.navbar-item:hover,
.navbar.is-primary .navbar-end > .navbar-item a.navbar-link:hover {
  border-bottom: 4px solid $white-ter;
  color: $white-ter !important;
}

.navbar-brand > a.navbar-item,
.navbar-brand > a.navbar-item.is-active,
.navbar-burger:hover,
.navbar-item.has-dropdown:hover .navbar-link {
  background-color: transparent !important;
}

.navbtn {
  margin-left: 1rem;
  font-size: 1.2rem;
}
@media screen and (max-width: $desktop) {
  .navbtn {
    margin-left: 0.75rem;
    margin-bottom: 1.5rem !important;
  }
  .navbar.is-primary .navbar-end > a.navbar-item.is-active,
  .navbar.is-primary .navbar-end > a.navbar-item:hover,
  .navbar.is-primary .navbar-end > .navbar-item a.navbar-link:hover {
    border-bottom: 0px solid $white;
    color: $info !important;
  }
}
</style>
